<!-- Titolo, contenuto e fascia delle azioni sono figli DIRETTI della superficie
     (niente <div> di raggruppamento): e' la condizione perche' la veste
     .izy-info-dialog-panel tenga la fascia panna a filo del bordo inferiore.
     La riga di avviso sul caricamento sta dentro il contenuto e non fra il
     titolo e il contenuto, dove sarebbe un quarto figlio della superficie e
     romperebbe la disposizione. -->
<h2 mat-dialog-title>Prenota una call con un nostro esperto</h2>

<mat-dialog-content class="izy-booking-content">
  <p class="izy-booking-hint">
    Il caricamento del calendario potrebbe richiedere qualche secondo.
  </p>

  @if (isLoading) {
    <div class="izy-booking-loading">
      <mat-spinner diameter="50"></mat-spinner>
      <p class="izy-booking-loading-label">Caricamento calendario...</p>
    </div>
  }

  <!-- Il widget e' di un servizio esterno: la sua veste non la decidiamo noi,
       quindi il linguaggio BEIZY resta sulla cornice - titolo, fascia delle
       azioni, contorno della superficie. -->
  <iframe
    [hidden]="isLoading"
    (load)="onIframeLoad()"
    class="izy-booking-frame"
    src="https://updates.actiwise.biz/widget/booking/kjZpCi2Ei9hlPtDAhsuk"
    scrolling="no"
    id="kjZpCi2Ei9hlPtDAhsuk_1774878488942">
  </iframe>

  <div [hidden]="isLoading" id="form_embed_script_container"></div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="izy-dialog-actions">
  <button
    mat-stroked-button
    type="button"
    mat-dialog-close
    class="izy-button-ghost custom-button-border">
    <mat-icon>arrow_back</mat-icon>
    Torna alle chat
  </button>
</mat-dialog-actions>
